import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, InfoIcon } from 'lucide-react';
import { alert } from '../data/homepage';
const ease = [0.23, 1, 0.32, 1] as const;
export function AlertBar() {
  const [expanded, setExpanded] = useState(false);
  return <div className="w-full bg-ville-navy text-white" data-id="element-71" data-mp="3tm42hl1ezf5a">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10" data-id="element-72" data-mp="3tksv7b8rfp9f">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 py-2.5" data-id="element-73" data-mp="l8eygcj1sb04">
          <InfoIcon className="h-4 w-4 shrink-0 text-ville-lime" aria-hidden="true" data-id="element-74" data-mp="p8yv7ezplclq" />
          <p className="text-sm font-semibold" data-id="element-75" data-mp="b965nmzx52fc">{alert.title}</p>
          {!expanded && <p className="hidden text-sm text-white/70 sm:block" data-id="element-76" data-mp="bba7lze9brcz">{alert.detail}</p>}
          <button type="button" onClick={() => setExpanded(v => !v)} aria-expanded={expanded} aria-controls="alerte-details" className="ml-auto inline-flex items-center gap-1.5 rounded text-sm font-semibold text-ville-lime transition-colors duration-150 ease-ville hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-lime" data-id="element-77" data-mp="g665vha37ayj">
            {expanded ? 'Voir moins' : 'Détails'}
            <motion.span animate={{
            rotate: expanded ? 180 : 0
          }} transition={{
            duration: 0.2,
            ease
          }} className="inline-flex" data-id="element-78" data-mp="22v6ed8e4459w">
              <ChevronDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-79" data-mp="2bu03yet0zvdy" />
            </motion.span>
          </button>
        </div>

        <AnimatePresence initial={false} data-id="element-80" data-mp="27t7txjcbxmgm">
          {expanded && <motion.div id="alerte-details" key="details" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          height: {
            duration: 0.28,
            ease
          },
          opacity: {
            duration: 0.18,
            ease
          }
        }} className="overflow-hidden" data-id="element-81" data-mp="2ljtgbi0zsej9">
              <motion.div initial={{
            y: -6
          }} animate={{
            y: 0
          }} exit={{
            y: -6
          }} transition={{
            duration: 0.24,
            ease
          }} className="max-w-3xl border-t border-white/10 pb-4 pt-3 text-sm leading-relaxed text-white/80" data-id="element-82" data-mp="2xl2w2qq8k1z6">
                {alert.body.map((paragraph, index) => <p key={paragraph} className={index === 0 ? undefined : 'mt-2'} data-id="element-83" data-mp="3had9fy2ieau4" data-mpi={index}>
                    {paragraph}
                  </p>)}
                <p className="mt-2 text-white/60" data-id="element-84" data-mp="3qc3031okh5qu">{alert.scope}</p>
              </motion.div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
}